import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";
import { Functions } from "../../../helpers/Functions.jsx";

const RolPorNivelAprobacionModal = ({ show, onClose, onSave, showLevelsAprobation, title, detalles, selectRoles }) => {
    const { handleSubmit: handleSubmitModal, register: registerModal, reset: resetModal, getValues: getValuesModal, setValue: setValueModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
    const [detallesRender, setDetallesRender] = useState(CONFIGURACIONES.INIT.ARRAY);

    useEffect(() => {
        resetModal();
        // if (initData !== CONFIGURACIONES.INIT.NULL) {
        //     setValueModal('totalUnidadFamiliar', initData.total);
        //     setDetalles(initData.detalles);
        // }
        setDetallesRender(detalles)
    }, [detalles, selectRoles]);


    const onAgregarItem = (form) => {
        const idEnUso = detallesRender.some(item => item.cargoEmpleadoId === form.cargoEmpleadoId);
        if (idEnUso) { alert('Elemento agregado previamente.'); return;}

        let form2 = {
            'id': Functions().generarNumeroUnico(detallesRender),
            'nombre': form.rol,
            'cargoEmpleadoId': form.cargoEmpleadoId
        }
        setDetallesRender([...detallesRender, form2]);
        resetModal();
    };

    const saveData = () => {
        let data = {
            'detalles': detallesRender
        }

        onSave(data);
    };

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(onAgregarItem)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 col-md-5">
                                <div className="form-group">
                                    <label htmlFor="tipoRol" className="control-label col-form-label">Rol del Negocio <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("tipoRol", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            onChange: (e) => {
                                                let rolSelected = e.target.value.split('@@')
                                                setValueModal('rol', rolSelected[1]);
                                                setValueModal('cargoEmpleadoId', rolSelected[0]);
                                            }
                                        })} className="form-control" id="tipoRol"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                           selectRoles.map((el, index) => (
                                                <option key={index} value={`${el.id}@@${el.nombre}`}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <input type="hidden" name="rol" {...registerModal('rol', {required: OWASP.REQUIRED})} />
                                    <input type="hidden" name="cargoEmpleadoId" {...registerModal('cargoEmpleadoId', {required: OWASP.REQUIRED})} />
                                   <small className="invalid-feedback"> { errorsModal.tipoRol && errorsModal.tipoRol.message }</small>
                                </div>
                            </div>
                        </div>

                        <div className="row my-1">
                            <div className="col-sm-12 col-md-3">
                                <WaveButton className="btn btn-sm btn-outline-info wave-effect" type="submit">
                                    <i className="mdi mdi-plus"></i> Agregar
                                </WaveButton>
                            </div>
                        </div>

                        {/* 📊 Tabla */}
                        <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                            <table className="table table-sm table-hover compact-table align-middle text-wrap">
                                <thead className="bg-success text-white">
                                <tr>
                                    <th>Rol del Negocio</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {detallesRender.length > 0 ? (
                                    detallesRender.map((item) => (
                                        <tr key={item.id}>
                                            <td className="text-wrap">{item.nombre}</td>
                                            <td>
                                                <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={() => {
                                                    setDetallesRender(detallesRender.filter((detalle) => detalle.id !== item.id));
                                                }}>
                                                    <i className="mdi mdi-delete"></i>
                                                </WaveButton>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="text-center text-muted">
                                            <span className="text-danger">No se encontraron resultados</span>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showLevelsAprobation && <WaveButton type="button" className="btn btn-sm btn-success waves-effect" onClick={saveData}>
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default RolPorNivelAprobacionModal;
